import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// eslint-disable-next-line react/prop-types
const HistoryListItemSkeleton = ({ index }) => {
  const backgroundColor = index % 2 !== 0 ? '#EFEFEF' : '#FFFFFF';
  const skeletonColor = index % 2 !== 0 ? '#FFFFFF' : '#EFEFEF';
  return (
    <div style={{ backgroundColor }} className="py-2">
      <div className="row">
        <div className="col ml-3">
          <Skeleton width={600} baseColor={skeletonColor} highlightColor={backgroundColor} />
        </div>
      </div>
      <div className="row">
        <div className="col ml-5">
          <Skeleton width={300} baseColor={skeletonColor} highlightColor={backgroundColor} />
        </div>
      </div>
      <div className="row">
        <div className="col ml-5">
          <Skeleton width={300} baseColor={skeletonColor} highlightColor={backgroundColor} />
        </div>
      </div>
      <div className="row">
        <div className="col ml-5">
          <Skeleton width={300} baseColor={skeletonColor} highlightColor={backgroundColor} />
        </div>
      </div>
      <div className="row">
        <div className="col ml-5">
          <Skeleton width={300} baseColor={skeletonColor} highlightColor={backgroundColor} />
        </div>
      </div>
    </div>
  );
};

export default HistoryListItemSkeleton;
